import React, { Component } from 'react';
import * as api from '../../api/api';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Grid, GridCell } from 'rmwc/Grid';
import { Card } from 'rmwc/Card';
import { Typography } from 'rmwc/Typography';
import { ListDivider } from 'rmwc/List';

import StatusMessage from '../../util/StatusMessage'
import {TextField} from 'rmwc/TextField';
import { FormField } from 'rmwc/FormField';
import { Select } from 'rmwc/Select';

class AdminHallTicketVersion extends Component {

  constructor(props){
    super(props);
    this.state = {
      hallTicketDetails: [],
      errorMsg: '',
    }
  }

  componentDidMount() {
    return api.getHallTicketVersionDetails(this.props.user.accessToken,this.props.match.params.hallticketId, this.props.match.params.userId)
    .then((result) => {
      if(result.status === 'success'){
        this.setState({
          hallTicketDetails: result.data
        })
      }
      else {
        this.setState({
          errorMsg: result.data
        })
      }
    }).catch((err) => {
      this.setState({ errorMsg: 'Error Occurred. Plaase contact Admin' })
    })
  }

  handleGoBack = () => {
    this.props.history.push(`/portal/app/admin/hallticket/details`)
  }

  render() {
    let displayComponent;
    displayComponent = (<tbody>
      {this.state.hallTicketDetails.map(function (hallticket){
        let version = hallticket.version_object
        return (<tr>
          <td>{version.hallticket_id}</td>
          <td>{version.user_id}</td>
          <td>{hallticket.user_name}</td>
          <td>{version.name}</td>
          <td>{version.roll_number}</td>
          <td>{hallticket.updated_user}</td>
          <td>{hallticket.update_at}</td>
          <td>{version.email}</td>
          <td>{version.mobile}</td>
          <td>{hallticket.test_city}</td>
          <td>{hallticket.test_track}</td>
          <td>{version.test_time_slot}</td>
          <td>{version.duration}</td>
          <td>{version.reporting_time}</td>
          <td>{version.pin_value}</td>
          <td>{version.test_location}</td>
          <td>{version.test_location_address}</td>
          <td>{version.pincode}</td>
          <td>{version.landmark}</td>
          <td>{hallticket.country}</td>
        </tr>)
      })}
      </tbody>)
    return(
      <div>
        <Grid>
          <GridCell span="10">
            <Typography use="headline5"><u>Hall Ticket Updated Version Details</u></Typography>
          </GridCell>
          <GridCell span="2">
            <Button onClick={this.handleGoBack}>BACK </Button>
          </GridCell>
          <GridCell span="12">
            <ListDivider/>
            <br/>
            <table>
              <th>HallTicket ID</th>
              <th>User ID</th>
              <th>User Name</th>
              <th>Name</th>
              <th>Roll number</th>
              <th>Updated By</th>
              <th>Snapshot Created Time</th>
              <th>email</th>
              <th>Mobile</th>
              <th>Test City</th>
              <th>Test track</th>
              <th>Test Slot Time</th>
              <th>Test duration</th>
              <th>Reporting Time</th>
              <th>Pin</th>
              <th>Test Centre</th>
              <th>Test Centre Address</th>
              <th>Pincode</th>
              <th>Land Mark</th>
              <th>Country</th>
              {displayComponent}
            </table>
            <StatusMessage error_msg = {this.state.errorMsg}/>
          </GridCell>
        </Grid>
      </div>
    );
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminHallTicketVersion);


// WEBPACK FOOTER //
// ./src/views/admin/AdminHallTicketVersion.jsx